import {
  KeycloakProfile,
  Usuario,
  UsuarioFuncionalidade,
  UsuarioPerfil,
  VinculoUsuarioOperadora,
} from '@gestor-web/@core/api/ords/model';
import { createAction, props } from '@ngrx/store';

export const getFullProfile = createAction('[UserProfile] Get User Full Profile');

export const getIdssProfile = createAction('[UserProfile] Get User IDSS Profile');

export const getKeycloakProfile = createAction('[UserProfile] Get User Keycloak Profile');

export const getIdssProfileSuccess = createAction(
  '[UserProfile] User IDSS Profile -> Success',
  props<{ idss: Usuario; operadoras?: VinculoUsuarioOperadora[] }>(),
);

export const getIdssProfileFailure = createAction(
  '[UserProfile] User IDSS Profile -> Failure',
  props<{ status: number; message: string }>(),
);

/** Sem `regans`, o back-end devolve só as concessões do papel; com ele, soma as dos módulos da operadora. */
export const getFuncionalidades = createAction('[UserProfile] Get Funcionalidades', props<{ regans?: string }>());

export const getFuncionalidadesSuccess = createAction(
  '[UserProfile] Get Funcionalidades -> Success',
  props<{ funcionalidades: UsuarioFuncionalidade[] }>(),
);

export const getFuncionalidadesFailure = createAction(
  '[UserProfile] Get Funcionalidades -> Failure',
  props<{ status: number; message: string }>(),
);

export const getKeycloakProfileSuccess = createAction(
  '[UserProfile] Get User Keycloak Profile -> Success',
  props<{ kc: KeycloakProfile }>(),
);

export const completarCadastro = createAction('[UserProfile] Completar Cadastro');

export const editarCadastro = createAction('[UserProfile] Editar Cadastro');

export const cancelarEditarCadastro = createAction('[UserProfile] Cancelar Editar Cadastro');

export const salvarDadosComplementares = createAction(
  '[UserProfile] Salvar User IDSS Profile -> ...',
  props<{ idss: UsuarioPerfil }>(),
);

export const salvarDadosComplementaresSuccess = createAction(
  '[UserProfile] Salvar User IDSS Profile -> Success',
  props<{ idss: UsuarioPerfil; isNew: boolean }>(),
);

export const salvarDadosComplementaresFailure = createAction(
  '[UserProfile] Salvar User IDSS Profile -> Failure',
  props<{ message: string }>(),
);

export const cookiesConsentUpdate = createAction(
  '[UserProfile] Atualiza Informações de Cookies',
  props<{ showBanner: boolean; acceptAll: boolean }>(),
);

export const loginClienteIdpUpdate = createAction(
  '[UserProfile] Atualiza Cliente IDP de Login',
  props<{ loginClienteIdp: string }>(),
);
